import { RETIREMENT_STATE_PENSION_AGE } from "web_myplann/Inspiration/Retirement/constants";

export const getRetirementBridgeYears = (retirementAge: number): number =>
	Math.max(0, RETIREMENT_STATE_PENSION_AGE - retirementAge);
